import {
  Box,
  Button,
  ButtonGroup,
  Grid2,
  IconButton,
  Paper,
  Skeleton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "../../components/tables/DataTable";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import {
  FilterTitleBox,
  FiltersBox,
} from "../../components/layouts/OneViewBox";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../store/actions/modalAction";
import AsyncSearchBar from "../../components/inputs/AsyncSearchBar";
import PaddingBoxInDesktop from "../../components/layouts/PaddingBoxDesktop";

import { USER_ROLES } from "../../utils/constants";
import DashboardProductCounts from "../dashboard/DashboardProductCounts";
import ButtonComponentsUi from "../../components/button/ButtonComponentsUi";

const StockOfProductListUi = ({
  columns,
  list,
  filters,
  setFilters,
  loading,
  onExportClick,
  onChannelSaleClick,
  title,
  categoryType,
  setCategoryType,
  setSelectedButtonId,
  selectedButtonId,
  count,
  loadingCount
}) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const id = "product";
  const { settings } = useSelector((state) => state);

  return (
    <>
      <Box>
        <Paper
          sx={{
            width: "100%",
            padding: 4,
          }}
        >
          <Box
            mb={4}
            display="flex"
            justifyContent={"flex-start"}
            flexDirection="column"
            gap={isSmallScreen ? 2 : 4}
          >
            <Box>
              <Typography
                variant={isSmallScreen ? "h2" : "h3"}
                textAlign={isSmallScreen ? "left" : "left"}
                marginBottom={isSmallScreen ? "5px" : "0"}
                color={"#000"}
              >
                {title}
              </Typography>

            </Box>

            {loadingCount ? (
              <Box
                mt={4}
                mb={4}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  height: "15vh",
                }}
              >
                {[0, 1, 2, 3].map((row) => (
                  <Skeleton
                    key={row}
                    variant="rectangular"
                    width={"24%"}
                    height={120}
                    sx={{
                      borderRadius: "8px",
                      boxShadow:
                        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    }}
                  />
                ))}
              </Box>
            )
              :
              (<Grid2
                container
                mt={4}
                pl={2}
                gap={1}
                size={12}
                justifyContent={"space-between"}
              >
                {count?.length > 0 && count?.map((item) => (<>
                  <Grid2
                    display={"flex"}
                    mb={2}
                    width={"24%"}
                    flexDirection={"row"}
                    justifyContent={"flex-start"}
                    flexWrap={"wrap"}
                    size={count?.length.length / 3}
                  >
                    <ButtonComponentsUi onSubmit={() => {
                      setSelectedButtonId(item?._id);
                    }}
                      count={item?.count ?? 0}
                      colorType={selectedButtonId === item._id}
                      Title={item?.product_name}
                    />
                  </Grid2>
                </>))}
              </Grid2>)
            }

            <Box
              display="flex"
              justifyContent={isSmallScreen ? "space-between" : "space-between"}
              alignItems="center"
              mt={1}
            >
              <Box p={2} display={"flex"}>
                <Button
                  onClick={onExportClick}
                  sx={{
                    width: "12vw",
                    height: "5vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  variant="contained"
                >
                  <Typography variant="h5" >
                    Import
                  </Typography>
                </Button>
              </Box>

              <Box  sx={{ display: "flex", direction: "row", justifyContent:"space-between" }}>

                <Box p={2}>
                  <Button
                    onClick={onChannelSaleClick}
                    sx={{
                      width: "12vw",
                      height: "5vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    variant="contained"
                  >
                    <AddIcon /> 
                    <Typography variant="h4" sx={{ display: "flex" }}>
                      Sale
                    </Typography>
                  </Button>
                </Box>

                <Box p={2}>
                  <PaddingBoxInDesktop
                    sx={{
                      display: "flex",
                      width: "15vw",
                    }}
                  >
                    <AsyncSearchBar
                      fullWidth
                      title="Search By Product Name"
                      size="small"
                      placeholder={"Search By Product Name"}
                      defaultValue={filters?.search}
                      onChange={(changedVal) =>
                        setFilters({
                          ...filters,
                          pageNo: 1,
                          pageSize: 10,
                          search: changedVal,
                        })
                      }
                    />
                  </PaddingBoxInDesktop>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              minHeight: "40vh",
            }}
          >
            <DataTable
              columns={columns}
              rows={list?.result ? list?.result : []}
              count={list?.total ?? 0}
              filters={filters}
              setFilters={setFilters}
              loading={loading}
            />
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default StockOfProductListUi;
